import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import Masonry from "react-masonry-component";

import {
  Title,
  Section,
  Box,
  Text,
} from "../../components/Core";
import RotateImg from "../../components/RotateImg";
import { devWorks2 } from "../../data";
import { useWindowSize } from "../../hooks";
import { breakpoints } from "../../utils";

const WorkCard = styled(Box)``;
const WorkText = styled(Box)``;

const Grid = (props) => {
  const size = useWindowSize();

  const masonryOptions = {
    transitionDuration: 1000,
  };

  return size.width < breakpoints.lg ? (
    <Masonry
      options={masonryOptions}
      className={"masonry-grid row"}
      {...props}
    />
  ) : (
    <Row {...props} />
  );
};

const Works = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(devWorks2);
  }, []);

  return (
    <>
      {/* <!-- Works Area --> */}
      <Section className="position-relative pt-0">
        <Container>
          <Grid>
            {items.map((item, index) => (
              <Col md="4" key={index} className="filtr-item">
                <WorkCard className="position-relative" mb="30px">
                  {item.videolink !== undefined && <RotateImg
                    link={item.videolink}
                    imgSrc={item.thumbnail}
                  />}
                  {item.videolink === undefined && <RotateImg
                    link={item.link}
                    imgSrc={item.thumbnail}
                  />}
                  <Box pt="2.125rem">
                    <WorkText className="overflow-hidden text-center">
                      <Text variant="tag" mb="0.5rem">
                        {item.categories[0]}
                      </Text>
                      <Title variant="cardLg">
                        <a href={item.link} target="_blank" rel="noreferrer" >{item.brand} </a>
                      </Title>
                    </WorkText>
                  </Box>
                </WorkCard>
              </Col>
            ))}
          </Grid>
        </Container>
      </Section>
    </>
  );
};

export default Works;
